import { useAiApiClient } from "#lib/AiApiClient.ts";
import { AiMutationKeys } from "#lib/AiQueryKeys.ts";
import type { DeleteFileCommand } from "#types/types.ts";
import { useMutation } from "@tanstack/react-query";

export const useDeleteFileMutation = () => {
    const { deleteConversationFile } = useAiApiClient();

    return useMutation({
        mutationKey: AiMutationKeys.DeleteFile(),
        mutationFn: async (payload: DeleteFileCommand) => {
            await deleteConversationFile(payload);
        }
    });
};
